export const sleep = (ms = 1000) => new Promise((res) => setTimeout(res, ms));
const toHTMLElement = (el) => {
    if (el instanceof HTMLElement)
        return el;
    const id = el.startsWith("#") ? el.substring(1) : el;
    return document.getElementById(id);
};
export const waitForElement = async (elOrId, parentElement, timeoutInMs) => new Promise((resolve, reject) => {
    const element = toHTMLElement(elOrId);
    if (element) {
        return resolve(element);
    }
    let timeout;
    if (timeoutInMs) {
        timeout = setTimeout(() => {
            reject(new Error(`Timeout: ${typeof elOrId === "string" ? elOrId : "renderer element"} not found`));
            observer.disconnect();
        }, timeoutInMs);
    }
    const observer = new MutationObserver(() => {
        const element = toHTMLElement(elOrId);
        if (element) {
            resolve(element);
            observer.disconnect();
            if (timeout)
                clearTimeout(timeout);
        }
    });
    observer.observe(parentElement ?? document.body, {
        childList: true,
        subtree: true
    });
});
